module.exports = __webpack_public_path__ + "img/gxpt.53cd0a29.svg";